import { io, Socket } from 'socket.io-client';
import { environment } from 'src/environments/environment';

export function videoSocketOptions(token: string) {
  return {
    transports: ['websocket', 'polling'],
    withCredentials: false,
    auth: { token },
  };
}

export const videoSocket = {
  connect(token: string): Socket {
    return io(environment.WS_URI, videoSocketOptions(token));
  },
};
